import { Fragment, Slice } from '@tiptap/pm/model'
import type { EditorView } from '@tiptap/pm/view'

export const stripAllMarksFromSlice = (slice: Slice, view: EditorView): Slice => {
  const text = slice.content.textBetween(0, slice.content.size, '\r\n', ' ')
  if (!text) return slice

  const textNode = view.state.schema.text(text)
  const newFragment = Fragment.from(textNode)
  return new Slice(newFragment, slice.openStart, slice.openEnd)
}
